import { UUID } from '../../uuid';


export class Layout {
    id: string; 
    name: string = '';
    items: LayoutItem[] = [];
    constructor(id: string, name: string, items: LayoutItem[]) {
        this.name = name;
        this.items = items;
        this.id = id;
    }
}

export class LayoutItem {

    // tslint:disable-next-line: variable-name
    _id: string;

    height = 4; // æ¯å *cellheight
    width = 4; // æ¯å *width
    minHeight?: number;
    minWidth?: number;
    maxHeight?: number;
    maxWidth?: number;
    x: number;
    y: number;
    componentName: string;
    get id() {
        return this._id;
    }
    set id(val: string) {
        this._id = val;
    }
    dataOptins: any;

    constructor(js?: any) {
        if (js !== undefined) {
            this.height = js['height'];
            this.width = js['width'];
            this.minHeight = js['minHeight']; 
            this.minWidth = js['minWidth'];
            this.maxHeight = js['maxHeight'];
            this.maxWidth = js['maxWidth'];
            this.x = js['x'];
            this.y = js['y'];
            this.componentName = js['componentName']; 
            if (js['id'] !== undefined) this._id = js['id'];
            else {
                this._id = UUID.uuid(10);
            }
            this.dataOptins = js['dataOptins'];
        }
    }

    static fromJS(js: any) {
        return new LayoutItem(js);
    }

}


export class CreateLayoutEntity {
    name: string;
}

export class DeleteLayoutEntity {
    name: string;
}
